<div class="relative flex min-w-0 flex-auto flex-col overflow-hidden">
    @if( isHeaderFooterRequired){
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none sm:h-20 md:px-6 print:hidden">
        <!-- Logo -->
        <div class="mx-2 flex items-center lg:mr-8">
            <a routerLink="/" class="hidden lg:flex">
                <img class="w-24 dark:hidden" src="images/logo/logo-text.svg" alt="logo" />
                <img class="hidden w-24 dark:flex" src="images/logo/logo-text-on-dark.svg" alt="logo" />
            </a>
            <a routerLink="/" class="lg:hidden">
                <img class="flex w-24 lg:hidden" src="images/logo/logo.svg" alt="logo" />
            </a>
        </div>
    </div>
    }

    <!-- Header & Cards -->
    <div class="relative overflow-hidden px-6 pb-12 pt-8 sm:px-16">
        <!-- Background -->
        <!-- prettier-ignore -->
        <svg class="-z-1 absolute inset-0" viewBox="0 0 960 540" width="100%" height="100%"
            preserveAspectRatio="xMidYMax slice" xmlns="http://www.w3.org/2000/svg">
            <g class="opacity-40 text-gray-200 dark:text-gray-800" fill="none" stroke="currentColor" stroke-width="100">
                <circle r="234" cx="196" cy="23"></circle>
                <circle r="234" cx="790" cy="491"></circle>
            </g>
        </svg>
        <!-- Header -->
        <!-- @if(isToUpgrade){
        <div class="flex flex-col items-center">
            <h2 class="text-xl font-semibold">PRICING</h2>
            <div class="mt-1 text-center text-4xl font-extrabold leading-tight tracking-tight sm:text-7xl">
                Boost your productivity with the right plan
            </div>
            <div class="text-secondary mt-3 text-center tracking-tight sm:text-2xl">
                <div class="">Start with the essentials, and upgrade as your needs evolve.</div>
                <div class=""> Upgrade to unlock more features and flexibility.</div>
            </div>
        </div>
        }@else { -->
        <div class="flex flex-col items-center">
            <!-- <h2 class="text-xl font-semibold">PRICING</h2> -->
            <div class="mt-1 text-center text-4xl font-extrabold leading-tight tracking-tight sm:text-7xl">
                Pricing & Plans
            </div>
            <div class="text-secondary mt-3 text-center tracking-tight sm:text-2xl">
                <div class="">Select the Subscription that Best Suits You</div>
            </div>
            <div class="mt-3 flex items-center overflow-hidden rounded-full bg-gray-200 p-0.5 dark:bg-gray-700 sm:mt-4">
                <button class="px-6" [ngClass]="{
                    'bg-card pointer-events-none shadow': yearlyBilling,
                    'bg-transparent': !yearlyBilling,
                }" mat-flat-button (click)="yearlyBilling = true" disableRipple>
                    Annual Billing
                </button>
                <button class="px-6" [ngClass]="{
                    'bg-card pointer-events-none shadow': !yearlyBilling,
                    'bg-transparent': yearlyBilling,
                }" mat-flat-button (click)="yearlyBilling = false" disableRipple>
                    Monthly Billing
                </button>
            </div>
        </div>
        <!-- } -->

        <!-- Cards -->
        <div class="mt-8 flex justify-center sm:mt-10">
            <div class="w-full max-w-sm md:max-w-7xl">
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 ">
                    @for(plan of plansListing; track plan){
                    <fuse-card class="max-w-100 ml-30 flex-col p-6 sm:px-10 sm:py-12  "
                        [ngClass]="{'ring-2 ring-primary overflow-visible': plan.isPopular || plan.isSelected}">
                        <div class="justify-between flex-auto">
                            @if(plan.isPopular ||plan.isSelected) {
                            <div class="absolute inset-x-0 -top-4 flex items-center justify-center">
                                <div
                                    class="flex h-8 items-center rounded-full bg-primary px-8 text-center font-medium leading-none text-on-primary">
                                    {{plan.isPopular?'POPULAR':'ACTIVE PLAN'}}
                                </div>
                            </div>
                            }
                            <div class="text-4xl font-bold leading-tight tracking-tight">
                                {{plan.title}}
                            </div>

                            <div class="text-secondary mt-2 text-lg font-medium tracking-tight">
                                {{plan.description}}
                            </div>

                            <div class="mt-10 h-1 w-8 rounded bg-accent"></div>
                            <!-- Features -->
                            <div class="my-10 flex flex-col">
                                <div class="mt-4 space-y-2">
                                    @for(feature of plan.featureListing; track feature){
                                    <div class="flex">
                                        <mat-icon class="text-green-600 icon-size-5"
                                            [svgIcon]="'heroicons_solid:check'"></mat-icon>
                                        <div class="ml-2 leading-5">
                                            {{feature}}
                                        </div>
                                    </div>
                                    }
                                </div>
                            </div>

                            <!-- Price -->
                            @if(!plan.hasNoPrice){
                            <div class="flex items-baseline whitespace-nowrap">
                                <div class="mr-2 text-2xl"> {{plan.currency}}</div>
                                <div class="text-6xl font-semibold leading-tight tracking-tight">
                                    @if (yearlyBilling) {
                                    {{plan.yearly | currency: plan.currency}}
                                    }
                                    @if (!yearlyBilling) {
                                    {{plan.monthly | currency: plan.currency}}
                                    }
                                </div>
                            </div>

                            <!-- Price details -->
                            <div class="text-secondary mt-2 flex flex-col">
                                @if (yearlyBilling) {
                                <div>billed yearly per user</div>
                                }
                                @if (!yearlyBilling) {
                                <div>billed monthly per user</div>
                                }
                            </div>
                            }
                            <!-- CTA -->
                        </div>
                        @if(plan.isPopular || plan.isSelected){
                        <button class="fuse-mat-button-large mt-10" mat-flat-button [color]="'primary'"
                            [ngClass]="{'cursor-not-allowed':plan.isSelected}"
                            (click)="plan.isPopular?onGetStarted(plan):null" [disabled]="plan.isSelected">
                            {{plan.isPopular?'Start Trial':'Active Plan'}}
                        </button>
                        }
                        @else {
                        <button class="fuse-mat-button-large mt-10" mat-stroked-button [color]="'primary'"
                            (click)="onGetStarted(plan)">
                            Start Trial
                        </button>
                        }
                    </fuse-card>
                    }
                </div>
            </div>
        </div>
    </div>

    @if( isHeaderFooterRequired){
    <div
        class="bg-card relative z-49 flex h-16 w-full flex-0 items-center border-t px-4 dark:bg-transparent md:px-6 print:hidden">
        <span class="text-secondary font-medium">&copy;{{currentYear}} {{ productName }}. All rights
            reserved.</span>
    </div>
    }
</div>